/**
 * SivirPainter — 2D Battle Mistress (gold crossblade cue).
 */
export const SivirPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.85, 0, Math.PI * 2);
    ctx.fillStyle = '#a16207';
    ctx.fill();

    ctx.beginPath();
    ctx.rect(-radius * 1.1, -3, radius * 2.2, 6);
    ctx.rect(-3, -radius * 1.1, 6, radius * 2.2);
    ctx.fillStyle = '#fef08a';
    ctx.fill();
  }
};
